import { render, staticRenderFns } from "./GroupMenu.vue?vue&type=template&id=37264a49&scoped=true&"
import script from "./GroupMenu.vue?vue&type=script&lang=js&"
export * from "./GroupMenu.vue?vue&type=script&lang=js&"
import style0 from "./GroupMenu.vue?vue&type=style&index=0&id=37264a49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37264a49",
  null
  
)

export default component.exports